import { NuffieldHealthTheme as NuffieldHealthMFTheme } from '@famly/mf_theme';
import BaseTheme from './base';
const NuffieldHealthChromeColor = NuffieldHealthMFTheme.colorPalette.brandColor;
const NuffieldHealthTheme = {
    ...BaseTheme,
    title: 'Nuffield Health Nursery',
    chromeColor: NuffieldHealthChromeColor,
    mf: NuffieldHealthMFTheme,
};
export default NuffieldHealthTheme;
